import React from 'react';

import { instagram } from '../../../services/api';
import InstagramSlideshow from './InstagramSlideshow';
import './instagram-feed.scss';

interface Props {
  applicant: Attendee;
}

interface State {
  loading: boolean;
  photos: any[];
  applicant: Attendee | null;
  modalSlideshow: Boolean;
  imageClicked: String;
}

class InstagramFeed extends React.Component<Props, State> {
  state: State = {
    photos: [],
    applicant: null,
    loading: false,
    modalSlideshow: false,
    imageClicked: '',
  };

  componentDidMount() {
    this.setState({
      applicant: this.props.applicant,
    });
    this.fetchPhotos();
  }

  componentDidUpdate() {
    if (this.props.applicant.id !== this.state.applicant?.id) {
      this.fetchPhotos();
      this.setState({
        applicant: this.props.applicant,
      });
    }
  }

  async fetchPhotos() {
    this.setState({ loading: true });

    if (this.props.applicant.model.instagram) {
      const data: any = await instagram.getMedia(this.props.applicant.model.instagram.id);
      // Only update if the returned instagram photos belong to the model we're viewing.
      if (data.data.user_social_id === this.props.applicant.model.instagram.id) {
        this.setState({
          photos: data.data.posts,
          loading: false,
        });
      }
    }
  }

  buildGrid() {
    let index = 1;
    const photos: any[] = [];
    this.state.photos.forEach((photo) => {
      photos.push(
        <div
          onClick={() => {
            this.setState({ modalSlideshow: true, imageClicked: photo.id });
          }}
          className="photo"
          key={photo.id + index}
        >
          <img src={photo.thumbnail_url} />
        </div>
      );
      index++;
    });

    return photos;
  }

  render() {
    if (this.state.loading) return 'Loading Instagram photos...';

    return (
      <>
        {this.state.modalSlideshow ? (
          <InstagramSlideshow
            id="instagram-slideshow"
            close={() => this.setState({ modalSlideshow: false })}
            images={this.state.photos}
            selectedImage={this.state.imageClicked}
          ></InstagramSlideshow>
        ) : null}

        <div className="instagram-photos">{this.buildGrid()}</div>
      </>
    );
  }
}

export default InstagramFeed;
